firebird.directive('header', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(helperService.getRedesignPathPrefix() + 'header.html'),
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
